<template>
  <el-drawer
    :size="width"
    v-model="showDialog"
    :before-close="handleClose"
    :direction="direction"
    class="customer-drawer"
  >
    <div class="left-block" v-if="!isHiddenOperation">
      <el-button type="primary" size="small" @click="addCollection">回款登记</el-button>
      <el-button type="primary" size="small" @click="addSign">签单登记</el-button>
      <el-button type="primary" size="small" v-if="buttons.includes('贷款计算按钮')" @click="showCalculate">贷款计算</el-button>
    </div>
    <div class="right-block" v-if="!isHiddenOperation">
      <el-button type="primary" size="small" @click="handleImport"
        >移入重要客户</el-button
      >
      <el-button type="primary" size="small" @click="handlePublicPool"
        >移入公海</el-button
      >
      <el-button type="primary" size="small" @click="handleRubbish"
      >放入垃圾库</el-button>

      <el-button type="primary" size="small" @click="handlePassage"
      >移入在途客户</el-button>
      <el-button type="primary" size="small" v-if="buttons.includes('移至轮转客户按钮')" @click="handleCirculation"
      >移入轮转客户</el-button>

      <el-button
        type="primary"
        size="small"
        @click="handlePrevCustomer"
        v-if="isRightOperation"
        >上一个</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="handleNextCustomer"
        v-if="isRightOperation"
        >下一个</el-button
      >
    </div>
    <el-tabs class="tabs-block" v-model="activeName">
      <el-tab-pane label="客户详情" name="1">
        <FormCustomer :forms="forms" :formData="formData" />
        <div class="content-customer">
          <div class="left fast-write">
            <h2>快捷录入</h2>
            <FormCustomer :forms="fastForms" :formData="formData" :rules="rules" />

            <el-button v-if="!isShowSaveBtn"
                type="primary"
                size="small"
                class="submit-btn"
                @click="handleSubmit"
            >保存</el-button
            >
            <h2 v-if="!isHiddenTX">
              <p>提醒事项</p>
              <el-button type="text" @click="addRemind">添加</el-button>
            </h2>
            <el-row>
              <el-col
                :span="24"
                class="remind-block"
                v-for="(item, index) in reminds"
                :key="index"
              >
                <el-date-picker
                  v-model="item.remindTime"
                  type="datetime"
                  size="small"
                  placeholder="选择日期时间"
                  value-format="YYYY-MM-DD HH:mm:ss"
                >
                </el-date-picker>
                <el-input
                  class="content-block"
                  v-model="item.content"
                  size="small"
                  placeholder="请输入内容"
                  clearable
                ></el-input>
                <!-- <el-radio-group
                  size="small"
                  v-model="item.status"
                >
                  <el-radio-button
                    v-for="(op, ind) in remindOptions"
                    :label="op.val"
                    :key="ind"
                  >{{op.label}}</el-radio-button>

                </el-radio-group> -->
                <el-button type="text" @click="handleSaveRemind(index, item.id)"
                  >保存</el-button
                >
                <el-button type="text" @click="handleDeleteRemind(index, item.id)"
                  >删除</el-button
                >
              </el-col>
            </el-row>
          </div>
          <div class="right">
            <el-tabs class="tabs-block" v-model="followActiveName">
              <el-tab-pane label="跟进记录备注" name="1">
                <ul class="remark-block">
                  <li v-for="(item, index) in followList" :key="index">
                    <div class="avatar-header" v-if="item.type==1">
                      <div class="avatar">{{ item.username.substring(0,1) }}</div>
                      <div>
                        <div class="header">
                          <div class="title">{{ item.username.length>3 ?item.username.substring(0,item.username.length -2): item.username }}</div>
                          <div class="time">{{ item.createTime }}</div>
                          <div v-if="buttons.includes('评论按钮')" @click="addFlowMarker(item.id)" style="font-size: 10px;margin-left: 5px;color: #6969df;cursor:pointer;">评</div>
                        </div>
                      </div>
                    </div>
                    <div class="content" v-if="item.type==1">
                      <div class="line-left" v-if="index != followList.length - 1">|</div>
                      <div class="line-left" v-else></div>
                      <div>
                        <div>{{ item.message }}</div>
                        <div>
                          <audio
                              v-if="item.voicePath"
                              :src="item.voicePath"
                              controls="controls"
                          >
                            Your browser does not support the audio element.
                          </audio>
                        </div>
                        <div @dblclick="replayComment(commentItem,item.userId)" style="font-size: 10px; color: #406fff" v-for="(commentItem, index) in item.followComments" :key="index">
                          <scan style="font-size: 12px;font-weight: 600; color: red">{{ commentItem.username }}:</scan>
                          <abbr v-bind:title= commentItem.comment>
                            {{ commentItem.comment }}
                          </abbr>
                          <div v-if="commentItem.reply" style="font-size: 10px; color: #406fff">
                            <scan style="font-size: 12px;font-weight: 600; color: red">{{ commentItem.replyUsername }}: </scan>
                            <scan style="font-size: 12px;font-weight: 600; color: #a8a8a8">@{{ commentItem.username }} //  </scan>
                            <abbr v-bind:title= commentItem.reply>
                               {{ commentItem.reply }}
                            </abbr>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </el-tab-pane>

              <el-tab-pane label="分配记录备注" name="2">
                <ul class="remark-block">
                  <li v-for="(item, index) in followList" :key="index">
                    <div class="avatar-header" v-if="item.type==0">
                      <div class="avatar">{{ item.username }}</div>
                      <div>
                        <div class="header">
                          <div class="title">{{ item.username }}</div>
                          <div class="time">{{ item.createTime }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="content" v-if="item.type==0">
                      <div class="line-left" v-if="index != followList.length - 1">|</div>
                      <div class="line-left" v-else></div>
                      <div>
                        <div>{{ item.message }}</div>
                        <div>
                          <audio
                              v-if="item.voicePath"
                              :src="item.voicePath"
                              controls="controls"
                          >
                            Your browser does not support the audio element.
                          </audio>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </el-tab-pane>

            </el-tabs>


<!--            <el-button-->
<!--              type="primary"-->
<!--              size="small"-->
<!--              class="submit-btn"-->
<!--              @click="handleSubmit"-->
<!--              >保存</el-button-->
<!--            >-->
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-drawer>
  <CollectionDialog
    title="回款登记"
    :isShowDialog="isShowCollection"
    :forms="collectionForms"
    :formData="collectionFormData"
    :width="600"
    @submit="handleCollectionSubmit"
    @close="handleCollectionClose"
  />
  <CollectionDialog
    title="签单登记"
    :isShowDialog="isShowSign"
    :forms="signForms"
    :formData="signFormData"
    :width="600"
    @submit="handleSignSubmit"
    @close="handleSignClose"
  />
  <CollectionDialog
      title="数据评论"
      :isShowDialog="isShowMarker"
      :forms="markerForms"
      :formData="markerFormData"
      :width="600"
      @submit="handleMarkerSubmit"
      @close="handleMarkerClose"
  />

  <CollectionDialog
      title="评论回复"
      :isShowDialog="isShowReplay"
      :forms="replayForms"
      :formData="replayFormData"
      :width="600"
      @submit="handleReplaySubmit"
      @close="handleReplayClose"
  />
  <CollectionDialog
      title="贷款计算"
      :isShowDialog="isShowCalculate"
      :forms="calculateForms"
      :formData="calculateFormData"
      :width="600"
      @submit="handleCalculateSubmit"
      @close="handleCalculateClose"
  />

  <CollectionDialog
      title="贷款计算"
      :isShowDialog="isShowCalculate2"
      :forms="calculateForms2"
      :formData="calculateFormData"
      :width="600"
      @submit="handleCalculateSubmit2"
      @close="handleCalculateClose2"
  />
</template>

<script>
import {
  ElButton,
  ElDatePicker,
  ElDrawer,
  ElMessage,
  ElRow,
  ElTabPane,
  ElTabs,
  ElCol,
  ElInput,
  ElRadioGroup,
  ElRadioButton,
  ElMessageBox,
} from "element-plus";
import { computed, reactive, ref, watch } from "vue";
import FormCustomer from "@/components/form";
import { forms, radioForms, collectionForms, signForms, markerForms, replayForms ,calculateForms, calculateForms2} from "./index.js";
import {
  getDictionaries,
  postRemind,
  putRemind,
  deleteRemind,
  postCollection,
  postSign,
} from "@/api/method/common";
import {
  putCustomer,
  getCustomer,
  movetoImportant,
  movetoPublicPool, movetoRubbish, movetoPassage,movetoCirculation,saveComment, saveReply
} from "@/api/method/customer";
import { reset } from "@/until";
import CollectionDialog from "@/components/dialog-form";
import {useStore} from "vuex";

export default {
  name: "DrawerForm",
  props: ["isShowDialog","isShowSaveBtn","isHiddenOperation","isHiddenTX", "width", "direction", "userId", "options", "isRightOperation"],
  components: {
    [ElDrawer.name]: ElDrawer,
    FormCustomer,
    [ElTabs.name]: ElTabs,
    [ElTabPane.name]: ElTabPane,
    [ElButton.name]: ElButton,
    [ElRow.name]: ElRow,
    [ElCol.name]: ElCol,
    [ElDatePicker.name]: ElDatePicker,
    [ElInput.name]: ElInput,
    [ElRadioGroup.name]: ElRadioGroup,
    [ElRadioButton.name]: ElRadioButton,
    CollectionDialog,
  },
  setup(props, context) {
    const { state } = useStore();
    const activeName = ref("1");
    const followActiveName = ref("1");
    const formData = reactive({
      name: null,
      mobile: null,
      age: null,
      sex: null,
      occupationId: null,
      educationId: null,
      marriageStatus: null,
      contractStatus: null,
      contractTime: null,
      loanLimit: null,
      annualIncome: null,
      room: 0,
      accumulation: 0,
      social: 0,
      car: 0,
      enterprise: 0,
      policy: 0,
      business: 0,
      issued: 0,
      starStatus: null,
      status: null,
      followRemark: null,
      followId: null,
      remark: null,
      userId: null,
    });
    const rules = reactive({
        followRemark: [{ required: true, message: "请输入跟进备注", trigger: "submit" }],
    })

    const fastForms = ref(radioForms);

    const dictionaries = async () => {
      let list;
      if (props.options) {
        list = props.options;
      } else {
        const res = await getDictionaries();
        list = res.data;
      }

      forms[1][0].option = list.occupationList.map((item) => ({
        label: item.label,
        val: item.vlaue,
      }));
      forms[1][1].option = list.educationList.map((item) => ({
        label: item.label,
        val: item.vlaue,
      }));
      fastForms.value[4][0].option = list.statusList.map((item) => ({
        label: item.label,
        val: item.vlaue,
      }));
      fastForms.value[4][1].option = list.starList.map((item) => ({
        label: item.label,
        val: item.vlaue,
      }));
      const arr = list.followList.map((item) => ({
        label: item.label,
        val: item.id,
      }));

      const arr2 = list.customeFollowList.map((item) => ({
        label: item.label,
        val: item.vlaue,
      }))

      const flowArr = [...arr,...arr2];
      fastForms.value[6][0].option = flowArr;
    };
    const submitForm = () => {
      context.emit("submit");
    };

    const showDialog = computed(() => props.isShowDialog);
    const resetForm = () => {};
    const handleClose = () => {
      context.emit("close");
      reset(formData);
    };

    watch(
      () => [props.userId, props.isShowDialog],
      () => {
        if (props.isShowDialog) {
          dictionaries();
          getDetail(props.userId);
        }
      }
    );
    watch(
      () => formData.followId,
      () => {
        if (formData.followId) {
          formData.followRemark = fastForms.value[6][0].option.find(
            (item) => item.val == formData.followId
          ).label;
        }
      }
    );

    const buttons = ref(localStorage.getItem("buttons").split(","));

    const formRef = ref(null)
    const handleSubmit = async () => {
        if(!formData.followRemark) {
            ElMessage.error("请输入跟进备注");
            return;
        }
        // eslint-disable-next-line no-unused-vars
        const { followId, ...params } = formData;
        const res = await putCustomer({ ...params });
        if (res.code == 200) {
            ElMessage.success("编辑成功！");
            await getDetail(props.userId);
            // handleClose();
        } else {
            ElMessage.error(res.msg);
        }
    };

    const followList = ref([]);

    const getDetail = async (id) => {
      const res = await getCustomer(id);
      const {
        name,
        mobile,
        age,
        sex,
        occupationId,
        educationId,
        marriageStatus,
        contractStatus,
        contractTime,
        loanLimit,
        annualIncome,
        room,
        accumulation,
        social,
        car,
        enterprise,
        policy,
        business,
        issued,
        status,
        starStatus,
        followRemark,
        remark,
        userId,
        followRecords,
        memorandums,
      } = res.data;
      formData.id = id;
      formData.name = name;
      formData.mobile = mobile;
      formData.age = age;
      formData.sex = sex;
      formData.occupationId = occupationId;
      formData.educationId = educationId;
      formData.marriageStatus = marriageStatus;
      formData.contractStatus = contractStatus;
      formData.contractTime = contractTime;
      formData.loanLimit = loanLimit;
      formData.annualIncome = annualIncome;
      formData.room = room;
      formData.accumulation = accumulation;
      formData.social = social;
      formData.car = car;
      formData.enterprise = enterprise;
      formData.policy = policy;
      formData.business = business;
      formData.issued = issued;
      formData.status = status;
      formData.starStatus = starStatus;
      formData.followRemark = followRemark;
      formData.remark = remark;
      formData.userId = userId;
      followList.value = followRecords;
      reminds.value = memorandums;
    };

    /**提醒事项 */

    const reminds = ref([]);
    // const remindOptions = reactive([
    //   { label: "已提醒", val: 1 },
    //   { label: "未提醒", val: 0 },
    // ]);
    const addRemind = () => {
      reminds.value.push({
        remindTime: null,
        content: null,
      });
    };

    const handleSaveRemind = async (index, id) => {
      if (id) {
        const res = await putRemind({
          customerId: props.userId,
          ...reminds.value[index],
        });
        if (res.code == 200) {
          ElMessage.success("修改成功");
          getDetail(props.userId);
        }
      } else {
        const res = await postRemind({
          customerId: props.userId,
          ststus: 0,
          ...reminds.value[index],
        });
        if (res.code == 200) {
          ElMessage.success("保存成功");
          getDetail(props.userId);
        }
      }
    };

    const handleDeleteRemind = (index, id) => {
      ElMessageBox.confirm("确定要删除该提醒事项吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteRemind(id);
          if (res.code == 200) {
            ElMessage({
              type: "success",
              message: "删除成功!",
            });
            reminds.value.splice(index, 1);
          } else {
            ElMessage({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch(() => {});
    };
    const addFlowMarker = (id) => {
      markerFormData.id = id;
      markerFormData.marker = null;
      isShowMarker.value = true;
    };
    /**添加回款 */
    const isShowCollection = ref(false);
    const addCollection = () => {
      isShowCollection.value = true;
    };
    const collectionFormData = reactive({
      amount: null,
      collectionDate: null,
      serviceCharge: null,
    });
    const handleCollectionSubmit = async () => {
      const res = await postCollection({
        customerId: props.userId,
        ...collectionFormData,
      });
      if (res.code == 200) {
        ElMessage.success("保存成功");
        isShowCollection.value = false;
      } else {
        ElMessage.error(res.msg);
      }
    };
    const handleCollectionClose = () => {
      isShowCollection.value = false;
    };


    const isShowReplay = ref(false);
    const isShowCalculate = ref(false);
    const isShowCalculate2 = ref(false);
    const replayFormData = reactive({
      id: null,
      replay: null
    });
    const calculateFormData = reactive({
      idNo: null,
      name: null,
      process: '电话核实',
      dked: null,
      shfs: '人工审核',
      hdlx: null,
      dkyt: '日常消费',
      result: '本次结果为系统评估，最终结果以银行签订的贷款合同为准'
    });

    const replayComment = async (commentItem, followUserId) => {
      const {id , reply} = commentItem;
      if (reply){
        ElMessage.error("每个评论只能回复一次哦！");
        return;
      }
      const followUser = formData.userId;
      if (followUser !== userInfo.value.id){
        ElMessage.error("您不是跟进人,不能回复该评论！");
        return;
      }
      console.log(followUser);
      if (followUserId !== userInfo.value.id){
        ElMessage.error("您不能对该条跟进评论进行回复！");
        return;
      }

      replayFormData.id = id;
      replayFormData.replay = null;
      isShowReplay.value = true;
    }

    const handleReplaySubmit = async () => {
      const res = await saveReply(replayFormData);
      if (res.code == 200) {
        isShowReplay.value = false;
        await getDetail(props.userId);
      } else {
        ElMessage.error(res.msg);
      }

      console.log(markerFormData)
    };

    const handleReplayClose = () => {
      isShowReplay.value = false;
    };

    const handleCalculateSubmit = async () => {
      isShowCalculate.value = false;
      calculateFormData.dked = (calculateFormData.dked+'').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      isShowCalculate2.value= true
    };

    const handleCalculateClose = () => {
      isShowCalculate.value = false;
    };

 const handleCalculateSubmit2 = async () => {
      isShowCalculate2.value= false
    };

    const handleCalculateClose2 = () => {
      isShowCalculate2.value = false;
    };

    const isShowMarker = ref(false);
    const markerFormData = reactive({
      id: null,
      marker: null
    });

    const handleMarkerSubmit = async () => {
      const res = await saveComment(markerFormData);
      if (res.code == 200) {
        ElMessage.success("保存成功");
        isShowMarker.value = false;
        await getDetail(props.userId);
      } else {
        ElMessage.error(res.msg);
      }

      console.log(markerFormData)
    };
    const handleMarkerClose = () => {
      isShowMarker.value = false;
    };

    /**添加签单 */
    const isShowSign = ref(false);
    const addSign = () => {
      isShowSign.value = true;
    };
    const showCalculate = () => {
      calculateFormData.idNo = "YHZD" + (new Date().getTime() - 1000000*1000000);
      calculateFormData.name = formData.name
      isShowCalculate.value = true;
    };
    const signFormData = reactive({
      amount: null,
      signDate: null,
      serviceCharge: null,
    });
    const handleSignSubmit = async () => {
      const res = await postSign({
        customerId: props.userId,
        ...signFormData,
      });
      if (res.code == 200) {
        ElMessage.success("保存成功");
        isShowSign.value = false;
      } else {
        ElMessage.error(res.msg);
      }
    };
    const handleSignClose = () => {
      isShowSign.value = false;
    };
    const handlePrevCustomer = () => context.emit("prev");
    const handleNextCustomer = () => context.emit("next");

    /**移入公海，重要客户 */
    const handleImport = async () => {
      const res = await movetoImportant([props.userId]);
      if (res.code == 200) {
        ElMessage.success("移入重要客户成功！");
        context.emit('list')
        context.emit('importList')
      } else {
        ElMessage.error(res.msg);
      }
    };

    const handlePublicPool = async () => {
      const res = await movetoPublicPool([props.userId]);
      if (res.code == 200) {
        ElMessage.success("移入公海成功！");
        context.emit('list')
      } else {
        ElMessage.error(res.msg);
      }
    };

    const handleRubbish = async () => {
      const res = await movetoRubbish([props.userId]);
      if (res.code == 200) {
        ElMessage.success("移入垃圾库成功！");
        context.emit('list')
      } else {
        ElMessage.error(res.msg);
      }
    };

    const handlePassage = async () => {
      const res = await movetoPassage([props.userId]);
      if (res.code == 200) {
        ElMessage.success("移入在途客户成功！");
        context.emit('list')
      } else {
        ElMessage.error(res.msg);
      }
    };

    const handleCirculation = async () => {
      const res = await movetoCirculation([props.userId]);
      if (res.code == 200) {
        ElMessage.success("移入轮转客户成功！");
        context.emit('list')
      } else {
        ElMessage.error(res.msg);
      }
    };

    const userInfo = computed(() => state.userInfo);

    return {
      activeName,
      followActiveName,
      submitForm,
      formData,
      resetForm,
      showDialog,
      handleClose,
      forms,
      fastForms,
      handleSubmit,
      followList,
      reminds,
      addRemind,
      handleSaveRemind,
      //   remindOptions,
      buttons,
      handleDeleteRemind,
      addCollection,
      isShowCollection,
      collectionForms,
      collectionFormData,
      handleCollectionSubmit,
      handleCollectionClose,
      isShowSign,
      isShowMarker,
      isShowReplay,
      isShowCalculate,
      isShowCalculate2,
      calculateForms,
      calculateForms2,
      userInfo,
      replayComment,
      addSign,
      showCalculate,
      handleSignClose,
      handleSignSubmit,
      handleMarkerClose,
      handleMarkerSubmit,
      handleReplaySubmit,
      handleReplayClose,
      handleCalculateSubmit,
      handleCalculateClose,
      handleCalculateSubmit2,
      handleCalculateClose2,
      markerFormData,
      replayFormData,
      calculateFormData,
      signFormData,
      signForms,
      markerForms,
      replayForms,
      addFlowMarker,
      handlePrevCustomer,
      handleNextCustomer,
      handleImport,
      handlePublicPool,
      handleRubbish,
      handlePassage,
      handleCirculation,
      rules,
      formRef
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/css/form";
.el-drawer {
  .el-drawer__body {
    padding: 0 20px;
    overflow: scroll;
  }
  .el-drawer__header {
    padding: 10px;
    margin: 0;
  }
}
.left-block {
  position: absolute;
  top: 40px;
  left: 100px;
  z-index: 1000000;
  .label {
    margin-left: 10px;
    cursor: pointer;
  }
}
.right-block {
  position: absolute;
  top: 40px;
  right: 20px;
  z-index: 1000000;
  .label {
    margin-left: 10px;
    cursor: pointer;
  }
}
.content-customer {
  display: flex;
  background-color: #f5f5fa;
  padding-top: 4px;
  h2 {
    display: flex;
    justify-content: space-between;
    line-height: 36px;
    font-size: 16px;
    height: 36px;
    border-bottom: 1px solid #f5f5fa;
    margin-bottom: 20px;
    padding: 0 20px;
  }
  .left {
    flex: 1;
    background-color: white;
    padding-right: 20px;
    .submit-btn {
      height: 110px;
      position: absolute;
      top: 520px;
      left: 40px;
      width: 70px;
    }
  }
  .right {
    margin-left: 10px;
    width: 300px;
    background-color: white;
    position: relative;
    .remark-block {
      padding: 0 15px;
      height: 666px;
      overflow-y: scroll;
      li {
        margin-bottom: 10px;
        .avatar-header {
          display: flex;
        }
        .avatar {
          width: 40px;
          height: 40px;
          background-color: #406fff;
          border-radius: 50%;
          color: white;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
          text-align: center;
        }
        .header {
          display: flex;
          margin-top: 10px;
        }
        .time {
          color: #999;
          margin-left: 5px;
        }
        .title {
          font-size: 16px;
          font-weight: bold;
        }
        .line-left {
          min-width: 50px;
          height: 24px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .content {
          color: #666;
          margin-top: 10px;
          display: flex;
        }
        audio {
          width: 220px;
          height: 60px;
        }
      }
    }
    .submit-btn {
      position: absolute;
      bottom: 30px;
      left: 140px;
    }
  }
  .remind-block {
    display: flex;
    .el-date-editor {
      min-width: 180px;
      margin: 0 10px;
    }
    .el-radio-group {
      min-width: 140px;
      margin: 0 10px;
    }
    .content-block {
      margin-right: 10px;
    }
  }
}

.tabs-block {
  .el-tabs__item.is-active {
    color: #406fff;
  }
  .el-tabs__active-bar {
    background: #406fff;
  }
  .el-tabs__nav-wrap::after {
    border: none;
  }
}
.fast-write {
  .el-form-item:nth-child(12) {
    display: none;
  }
}
.fast-write {
  .el-row:nth-child(7) {
    .el-radio-group {
      margin-left: 120px;
      .el-radio {
        margin-bottom: 10px;
      }
    }
  }
}

.el-icon-phone{
  font-size: 18px;
  color: #de0404;
}
</style>
